export enum ROUTES {
  REGISTER = 'register',
  PASSWORD = 'password',
  APP = 'app',
  MESSAGE = 'message',
  DOCUMENTS = 'documents',
  PUBLIC_DOCKET_SEARCH = 'docket-search'
}

